<template>
  <VaccinationPage
    title="Adolescents"
    :buttons="buttons"
    baseRoute="/secondAdolescentsPage"
    :bottomImage="require('@/assets/page6/Asset 18.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/secondAdolescentsPage"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page6/Asset 2.png"), name: "Influenza" },
  { imgPath: require("@/assets/page6/Asset 3.png"), name: "Adolescents" , disabled: true },
  { imgPath: require("@/assets/page6/Asset 4.png"), name: "Humanpapilloma" },
  { imgPath: require("@/assets/page6/Asset 5.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page6/Asset 6.png"), name: "Adolescents" , disabled: true  },
  { imgPath: require("@/assets/page6/Asset 7.png"), name: "MeningococcalMenB" },
  { imgPath: require("@/assets/page6/Asset 8.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page6/Asset 9.png"), name: "MMR" },
  { imgPath: require("@/assets/page6/Asset 10.png"), name: "Varicella" },
  { imgPath: require("@/assets/page6/Asset 11.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page6/Asset 3.png"), name: "Adolescents", disabled: true  },
  { imgPath: require("@/assets/page6/Asset 16.png"), name: "HepatitisB" },
];
</script>
